<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="1000"
    v-if="chat"
  >
    <v-card>
      <v-toolbar
        dark
      >
        <v-toolbar-title>
          Chat Session
        </v-toolbar-title>
        <div class="flex-grow-1"></div>
        <v-btn icon @click="onCloseClick()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-card flat style="overflow-y: auto; height: 300px; background-color: #F5F5F5;">
          <Exchange
            v-for="(item, index) in chat.conversation"
            :query="item.query"
            :response="item.response"
            :key="index"
          >
          </Exchange>
          <div
            v-if="chat.conversation && chat.conversation.length === 0"
            class="pa-3"
            style="background-color: black; color: white; text-align: center;"
          >
            NO EXCHANGES
          </div>
        </v-card>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn
          color="grey lighten-1"
          @click="onCloseClick()"
        >
          Cancel
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Exchange from './Exchange.vue';

export default {
  components: {
    Exchange,
  },

  props: {
    dialog: Boolean,
    chat: Object,
  },

  methods: {
    onCloseClick() {
      this.$emit('close');
    },
  },
};
</script>
